import { TreeNodeType } from '../interfaces/schemaExplorer';
import { SchemaExplorerFolder } from '../interfaces/schemaExplorerFolder';
import { HdKeyBadgesFactory } from '../../../badge/components/key-badge/key-badge';
import { getFieldDataTypeIcon } from '../../../core/utils/data-type-icon';
import { getFieldDataTypeDisplay } from '../../../containers/activate/MappingBox/utils';
import { SchemaRelationTypeGroupsFactory } from './relationsFactory';


export function SchemaExplorerFoldersFactory(rawData: any[]) {
  return rawData.map((table: any) => {
    return SchemaExplorerFolderFactory(table);
  });
}

export function SchemaExplorerFolderFactory(rawData: any): SchemaExplorerFolder {
  return {
    name: rawData.name,
    resourceType: rawData.destination_entity_type,
    files: SchemaExplorerFilesFactory(rawData.fields),
    relationGroups: SchemaRelationTypeGroupsFactory(rawData.relations),
    treeNodeType: TreeNodeType.FOLDER,
    id: rawData.id,
    collapsed: true
  };
}

export function SchemaExplorerFilesFactory(rawData) {
  return (rawData || []).map((field: any) => {
    return SchemaExplorerFileFactory(field);
  });
}

export function SchemaExplorerFileFactory(rawData) {
  return {
    name: rawData.name,
    dataType: getFieldDataTypeDisplay(rawData),
    treeNodeType: TreeNodeType.FILE,
    keys: HdKeyBadgesFactory({
      ...rawData.parameters,
      optional: rawData.optional
    }),
    dataTypeIcon: getFieldDataTypeIcon(rawData.type)
  };
}
